import { Alert } from "@mui/material";
import { useRouteError } from "react-router";

import { RobotoDomainException } from "@/shared/http";
/**
 * Top-most error boundary for the File route.
 *
 * Reference: https://reactrouter.com/en/main/route/error-element
 */
export function ErrorBoundary() {
  const error = useRouteError();

  if (error instanceof RobotoDomainException && error.isClientError()) {
    return (
      <Alert
        severity="error"
        sx={{
          fontSize: "1.125rem",
          margin: "1em 0",
        }}
      >
        {error.message}
      </Alert>
    );
  }

  return (
    <Alert
      severity="error"
      sx={{
        fontSize: "1.125rem",
        margin: "1em 0",
      }}
    >
      Something went wrong loading the file. Please try reloading the page.
    </Alert>
  );
}
